/**
 * Early attribution capture entry point.
 *
 * This file must be loaded synchronously in <head>
 * before analytics or tag managers execute.
*/

(function () {
  'use strict';

  window.__LMJ_INITIAL_HREF__ =
  window.__LMJ_INITIAL_HREF__ || window.location.href;

  if (window.Attribution && window.Attribution.initialized) return;

  window.Attribution = window.Attribution || {};
  window.Attribution.initialized = true;

  var stored = AttributionStorage.read() || {};

  // User-scoped landing (first ever for this user)
  var userFirstLandingUrl = stored.user_first_landing_url;

  if (!userFirstLandingUrl) {
    userFirstLandingUrl =
      window.__LMJ_INITIAL_HREF__ || window.location.href;
  }

  // IDs - handle user & session persistence across visits
  var userId = stored.lmj_user_id || AttributionUtils.getOrCreateUserId();
  var session = AttributionUtils.getOrCreateSessionId();

  var sessionLastActivity =
  stored.session_last_activity_at ||
  new Date().toISOString();

  // Session-scoped landing
  var sessionEntryUrl = session.sessionEntryUrl;

  if (!sessionEntryUrl) {
    sessionEntryUrl = stored.session_entry_url || '';
  }

  var sessionEntryReferrer =
    stored.session_entry_referrer_external || session.sessionEntryReferrer || '';

  var sessionId = session.id;

  // Attribution
  var firstTouch = stored.first_touch || null;
  var lastTouch = stored.last_touch || null;

  // Params
  var rawParams = AttributionUtils.getUrlParameters();
  var isFeed = AttributionUtils.isFeedAttribution(rawParams);
  var params = isFeed ? null : rawParams;
  var rawAllParams = AttributionUtils.getAllUrlParameters();

  var isPaidLanding = params && Object.keys(params).length > 0;
  var referrer = AttributionUtils.getReferrer();

  // Track first_touch_raw_params
  var rawDebugParams = stored.first_touch_raw_params || {};
  if (!stored.first_touch_raw_params || Object.keys(stored.first_touch_raw_params).length === 0) {
    rawDebugParams = Object.assign({}, rawAllParams || {});
  }

  // Track last_touch_raw_params
  var lastTouchRawDebug = stored.last_touch_raw_params || {};
  if (rawAllParams) {
    Object.keys(rawAllParams).forEach(function (key) {
      lastTouchRawDebug[key] = rawAllParams[key];
    });
  }

  // Direct paid landing
  if (isPaidLanding) {
    if (!firstTouch) {
      firstTouch = params;
    }
    if (!lastTouch) {
      lastTouch = params;
    } else {
      lastTouch = Object.assign({}, lastTouch, params);
    }
  }

  // -------------------
  // Payload
  // -------------------
  var payload = {
    lmj_user_id: userId,
    lmj_session_id: sessionId,

    // LANDINGS
    user_first_landing_url: userFirstLandingUrl,        // user-scoped
    session_entry_url: sessionEntryUrl,                // session-scoped
    session_entry_referrer_external: sessionEntryReferrer, // session-scoped

    session_last_activity_at: sessionLastActivity,

    // Attribution
    first_touch: firstTouch,
    last_touch: lastTouch,
    referrer: referrer || stored.referrer || null,

    // Raw / debug params
    first_touch_raw_params: rawDebugParams,
    last_touch_raw_params: lastTouchRawDebug,

    // Metadata
    consentMeta: AttributionConsent.getConsentMetadata(),
    device: AttributionUtils.getDeviceContext(),
    created_at: stored.created_at || new Date().toISOString(),
    updated_at: new Date().toISOString()
  };

  AttributionStorage.storePayload(payload);

  if (rawParams && Object.keys(rawParams).length > 0) {
      window.addEventListener('load', function() {
        AttributionUtils.cleanTrackingParameters();
      });
  }

  function pushTruthLedgerToDataLayer() {
    // Check if TruthLedger exists
    if (typeof AttributionTruthLedgerEvents === 'undefined') {
      // Try again in 100ms
      setTimeout(pushTruthLedgerToDataLayer, 100);
      return;
    }
    
    if (!window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
    }
    
    try {
      var tlFields = AttributionTruthLedgerEvents.getAllFields();
      
      window.dataLayer.push({
        'event': 'truth_ledger_ready',
        'tl_paid_flag': tlFields.tl_paid_flag,
        'tl_click_id_type': tlFields.tl_click_id_type,
        'tl_consent_status': tlFields.tl_consent_status
      });
      
    } catch (e) {
      console.error("[Attribution Core] Error pushing TL data:", e);
      // Retry once more
      setTimeout(pushTruthLedgerToDataLayer, 200);
    }
  }

  // Start the process but don't block
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pushTruthLedgerToDataLayer);
  } else {
    // Use setTimeout to ensure other scripts have a chance to load
    setTimeout(pushTruthLedgerToDataLayer, 50);
  }

})();